var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from './button-group.styles';
import { getOptionStyle } from './button-group.styles';
import { ButtonGroupTypes } from './models/ButtonGroupTypes';
import { useEffect } from 'react';
import { useState } from 'react';
import { classNames } from '../../utils';
export var ButtonGroup = function (_a) {
    var testId = _a.testId, type = _a.type, options = _a.options, selectedOptions = _a.selectedOptions, _b = _a.color, color = _b === void 0 ? 'primary' : _b, multiple = _a.multiple, onOptionSelected = _a.onOptionSelected, inputRef = _a.inputRef, className = _a.className, notSelectedColor = _a.notSelectedColor, textColor = _a.textColor;
    var _c = useState(selectedOptions), selectedValues = _c[0], setSelectedValues = _c[1];
    var isOptionSelected = function (option) {
        if (Array.isArray(selectedValues)) {
            return selectedValues.some(function (selectedOption) { return selectedOption === option.value; });
        }
        else {
            return option.value === selectedValues;
        }
    };
    var optionClicked = function (option) {
        if (multiple) {
            var newSelectedOptions = __spreadArray([], selectedValues, true);
            if (isOptionSelected(option)) {
                var indexOf = newSelectedOptions.indexOf(option.value);
                newSelectedOptions.splice(indexOf, 1);
            }
            else {
                newSelectedOptions.push(option.value);
            }
            setSelectedValues(newSelectedOptions);
            onOptionSelected(newSelectedOptions);
        }
        else {
            setSelectedValues(option.value);
            onOptionSelected(option.value);
        }
    };
    useEffect(function () {
        setSelectedValues(selectedOptions);
    }, [selectedOptions]);
    return (_jsx("div", __assign({ "data-testid": testId, className: classNames(className, type === ButtonGroupTypes.Button
            ? styles.buttonTypeWrapper
            : styles.chipTypeWrapper) }, { children: options &&
            options.map(function (option, index) {
                return (_jsx("div", __assign({ ref: inputRef, onClick: function () {
                        if (option.disabled)
                            return;
                        optionClicked(option);
                    }, className: "".concat(getOptionStyle(type, option.disabled), " ").concat(isOptionSelected(option)
                        ? styles.selected(color)
                        : notSelectedColor
                            ? styles.notSelectedColorStyle(notSelectedColor, textColor)
                            : styles.notSelectedButtonOrChip) }, { children: option.text }), "button-group-option-".concat(index)));
            }) })));
};
export default ButtonGroup;
//# sourceMappingURL=button-group.js.map